module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "jira-card"
    }
  }, _vm._l((_vm.jiraResults), function(result, index) {
    return _c('div', {
      key: index,
      staticClass: "jira-result"
    }, [_c('div', {
      staticClass: "jira-class",
      attrs: {
        "id": ("jira-item-" + index)
      }
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "jira-title"
    }, [(_vm.displayMethod !== 'single-ticket') ? _c('router-link', {
      ref: "routerLink",
      refInFor: true,
      staticClass: "title-style",
      attrs: {
        "to": {
          path: (_vm.routeKey + "/issue/" + (result.key))
        }
      }
    }, [_vm._v("\n            " + _vm._s(result.fields.summary) + " (" + _vm._s(result.key) + ")\n          ")]) : _vm._e(), _vm._v(" "), (_vm.displayMethod === 'single-ticket') ? _c('a', {
      ref: "routerLink",
      refInFor: true,
      staticClass: "title-style"
    }, [_vm._v("\n            " + _vm._s(result.fields.summary) + " (" + _vm._s(result.key) + ")\n          ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "jira-content"
    }, [_c('div', {
      staticClass: "jira-lines"
    }, [_c('div', {
      staticClass: "content-sub-lines"
    }, [_c('div', {
      staticClass: "content-title"
    }, [_vm._v("Erstellt: ")]), _vm._v(" "), _c('div', {
      staticClass: "jira-info",
      attrs: {
        "id": "createdDate"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.renderDate(result.fields.created)) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "content-sub-lines"
    }, [_c('div', {
      staticClass: "content-title"
    }, [_vm._v("Aktualisiert: ")]), _vm._v(" "), _c('div', {
      staticClass: "jira-info",
      attrs: {
        "id": "updatedDate"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.renderDate(result.fields.updated)) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "content-sub-lines"
    }, [_c('div', {
      staticClass: "content-title"
    }, [_vm._v("Status: ")]), _vm._v(" "), _c('div', {
      staticClass: "jira-info",
      class: 'sd-status sd-' +
        result.fields.status.statusCategory.colorName,
      attrs: {
        "id": "status"
      }
    }, [_vm._v("\n            " + _vm._s(result.fields.status.name) + "\n          ")])])]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "description"
      },
      domProps: {
        "innerHTML": _vm._s(result.renderedFields.description)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "comments-wrapper"
    }, [(_vm.preloadedComments === false) ? _c('div', {
      staticClass: "comments-button"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.commentOpenedIndex != index),
        expression: "commentOpenedIndex != index"
      }],
      on: {
        "click": function($event) {
          _vm.openComment(index);
          _vm.searchComments(result, index);
        }
      }
    }, [_vm._v("Kommentare einblenden\n          "), _c('img', {
      staticClass: "icon vertical expander",
      attrs: {
        "src": "/static/material_icons/expand_more.png"
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.commentOpenedIndex === index),
        expression: "commentOpenedIndex === index"
      }],
      on: {
        "click": function($event) {
          _vm.openComment(index);
        }
      }
    }, [_vm._v("Kommentare ausblenden\n          "), _c('img', {
      staticClass: "icon vertical expander",
      attrs: {
        "src": "/static/material_icons/expand_less.png"
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "jira-mail"
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.mailSubject(
            _vm.mailAddress,
            result.fields.summary,
            result.key)
        }
      }
    }, [_vm._v("\n          Kommentar hinzufügen +\n        ")])])]), _vm._v(" "), (_vm.preloadedComments || _vm.commentOpenedIndex === index) ? _c('div', {
      attrs: {
        "id": "comments-box"
      }
    }, [(_vm.loadingCom && !_vm.commentResult.length) ? _c('div', {
      staticClass: "comment-spinner"
    }, [_c('img', {
      attrs: {
        "src": "/static/spinner.svg",
        "height": "40",
        "width": "40"
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.commentResult), function(result, index) {
      return _c('div', {
        key: index,
        staticClass: "comment-elem"
      }, [_c('div', {
        staticClass: "comment-title"
      }, [_vm._v("\n          von "), _c('span', [_vm._v(_vm._s(result.author.displayName))]), _vm._v("\n          hinzugefügt am\n          " + _vm._s(_vm.renderDate(result.updated)) + "\n        ")]), _vm._v(" "), _c('div', {
        staticClass: "comment-body",
        domProps: {
          "innerHTML": _vm._s(result.renderedBody)
        }
      })])
    }), _vm._v(" "), (_vm.commentResult.length === 0 && !_vm.loadingCom) ? _c('div', {
      key: 'no-result',
      staticClass: "comment-title"
    }, [_vm._v("\n        Es gibt keine Kommentare\n      ")]) : _vm._e()], 2) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-314a0ba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/childs/JiraCard.vue
// module id = 425
// module chunks = 1